import { useQuery } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import { Pagination } from '../../../../lib/types/Pagination'
import { Vehicle } from '../../../../lib/types/Vehicle'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'

export const useGetInventoryBreakdownStats = ({
  type,
  filters,
}: {
  type: 'year' | 'make' | 'model'
  filters?: Record<string, any>
}) => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters ?? {})
  return useQuery(
    [
      'dealership',
      dealership?.id,
      'inventory',
      'analysis',
      'stats',
      'breakdown',
      { type },
      queryParams,
    ],
    ({ signal }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/inventory/stats/breakdown`,
        method: 'GET',
        params: {
          type,
          ...queryParams,
        },
        signal,
      }).then((res: any) => res.data),
    {
      enabled: !!dealership?.id,
      keepPreviousData: true,
    },
  )
}
